import { render, staticRenderFns } from "./MatchingStatsExportForm.vue?vue&type=template&id=1a766661&"
import script from "./MatchingStatsExportForm.vue?vue&type=script&lang=js&"
export * from "./MatchingStatsExportForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports